import { render } from "./OltPortsTable.vue?vue&type=template&id=7aed2d78"
import script from "./OltPortsTable.vue?vue&type=script&lang=js"
export * from "./OltPortsTable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__